// extracted by mini-css-extract-plugin
export default {"wrapper":"ServiceCard_wrapper__ZrQfB","title":"ServiceCard_title__23A1J","desc":"ServiceCard_desc__ype-y","icon":"ServiceCard_icon__V5n-y"};